export interface ProjectFeatureFlags {
  skipFinancialDataValidationOnIncome: boolean;
  hasProperties: boolean;
  hasSaveEmployementDetailsFunctionality: boolean;
  includeSaveBuyerTypeFunction: boolean;
  enableRegistroCivilFeature: boolean;
  enableCamaraComercioFeature: boolean;
  documentAnalyzerEnabled: boolean;
}

export interface ProjectCapabilities extends ProjectFeatureFlags {
  assignmentAgentEnabled: boolean;
}

export const FEATURE_FLAG_KEYS: ReadonlyArray<keyof ProjectFeatureFlags> = [
  'skipFinancialDataValidationOnIncome',
  'hasProperties',
  'hasSaveEmployementDetailsFunctionality',
  'includeSaveBuyerTypeFunction',
  'enableRegistroCivilFeature',
  'enableCamaraComercioFeature',
  'documentAnalyzerEnabled',
] as const;

interface FeatureFlagMeta {
  title: string;
  description: string;
}

export const INVERTED_FEATURE_FLAGS: ReadonlySet<keyof ProjectFeatureFlags> = new Set([
  'skipFinancialDataValidationOnIncome',
]);

export const flagToUi = (key: keyof ProjectFeatureFlags, apiValue: boolean): boolean =>
  INVERTED_FEATURE_FLAGS.has(key) ? !apiValue : apiValue;

export const flagToApi = (key: keyof ProjectFeatureFlags, uiValue: boolean): boolean =>
  INVERTED_FEATURE_FLAGS.has(key) ? !uiValue : uiValue;

export const FEATURE_FLAG_LABELS: Record<keyof ProjectFeatureFlags, FeatureFlagMeta> = {
  skipFinancialDataValidationOnIncome: {
    title: 'Validación Financiera',
    description: 'Activa la verificación de datos financieros al validar el ingreso del lead.',
  },
  hasProperties: {
    title: 'Tiene propiedades',
    description: 'Habilita el flujo de propiedades para este proyecto.',
  },
  hasSaveEmployementDetailsFunctionality: {
    title: 'Guardar detalles laborales',
    description: 'Permite registrar y almacenar información laboral del lead.',
  },
  includeSaveBuyerTypeFunction: {
    title: 'Guardar tipo de comprador',
    description: 'Activa la función que registra el tipo de comprador.',
  },
  enableRegistroCivilFeature: {
    title: 'Registro civil',
    description: 'Habilita validaciones contra el Registro Civil.',
  },
  enableCamaraComercioFeature: {
    title: 'Cámara de Comercio',
    description: 'Habilita validaciones contra la Cámara de Comercio.',
  },
  documentAnalyzerEnabled: {
    title: 'Analizador de documentos',
    description: 'Permite analizar documentos enviados por el lead.',
  },
};
